import React, { useEffect } from 'react'
import { useParams } from 'react-router';
import ExchangeInplay from './ExchangeInplay';

export default function InPlay() {
    const { eventId,mId } = useParams();

    useEffect(()=>{
    },[eventId,mId])

  return (
      <ExchangeInplay key={`${eventId}-${mId}`} eventId={eventId} mId={mId} />
  )
}
